// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");

function empty(param) {
  return {
          id: undefined,
          value: undefined,
          options: /* [] */0
        };
}

function options(t) {
  return t.options;
}

function id(t) {
  return t.id;
}

function value(t) {
  return t.value;
}

function setOptions(t, options) {
  return {
          id: t.id,
          value: t.value,
          options: options
        };
}

function decode(json) {
  var decodeValue = function (json) {
    var v = Json_decode.optional((function (param) {
            return Json_decode.field("value", Json_decode.string, param);
          }), json);
    if (v !== undefined) {
      return {
              hd: v,
              tl: /* [] */0
            };
    }
    
  };
  return {
          id: Json_decode.optional((function (param) {
                  return Json_decode.field("id", Json_decode.$$int, param);
                }), json),
          value: decodeValue(json),
          options: Json_decode.field("options", (function (param) {
                  return Json_decode.list(Json_decode.string, param);
                }), json)
        };
}

function encode(t) {
  return Json_encode.object_({
              hd: [
                "id",
                Json_encode.nullable((function (prim) {
                        return prim;
                      }), t.id)
              ],
              tl: {
                hd: [
                  "options",
                  Json_encode.list((function (prim) {
                          return prim;
                        }), t.options)
                ],
                tl: /* [] */0
              }
            });
}

var dataTypeName = "ListType";

exports.empty = empty;
exports.dataTypeName = dataTypeName;
exports.id = id;
exports.value = value;
exports.setOptions = setOptions;
exports.options = options;
exports.decode = decode;
exports.encode = encode;
/* No side effect */
